import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'

import PlanExtraHours from './PlanExtraHours.vue'
import PlanExtraHoursPanel from './PlanExtraHoursPanel.vue'

declareVconsoleComponent('planExtraHours', PlanExtraHours, 'plan:extra_hours');
declareVconsoleComponent('planExtraHoursPanel', PlanExtraHoursPanel, 'plan:extra_hours:panel')

